import { useState, useCallback } from "react";

const useFormValidation = (formFields) => {
  const [formValues, setFormValues] = useState(formFields);
  const [formErrors, setFormErrors] = useState({});
  const handleValidation = useCallback((e) => {
    const { name, value, type, checked } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: type === "checkbox" ? checked : value, // Handle checkbox separately
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Clear errors for the field
    }));
  }, []);
  return {
    formValues,
    setFormValues,
    formErrors,
    setFormErrors,
    handleValidation,
  };
};

export default useFormValidation;
